import Background from "./Background";
import SocialLinks from "./SocialLinks";
import Button from "../../components/UI/Button";
import Memoji from "../../components/Memoji/Memoji";

import styles from "./Home.module.css";

const Home = (props) => {
  return (
    <section className={styles["home-page"]}>
      <Background />
      <SocialLinks />
      <div className={styles["container"]}>
        <div className={styles["content-box"]}>
          <div className={styles["description"]}>
            <p className={styles["greeting"]}>Hello!!! I'm</p>
            <p className={styles["my-name"]}>HARSH GYANCHANDANI</p>
            <p className={styles["intro"]}>
              An Information Technology Undergraduate.
            </p>
          </div>
          <div className={styles["navigation-links"]}>
            <Button className="button--solid" onClick={props.onProjectsClicked}>
              Explore Projects &gt;
            </Button>
            <Button className="button--outlined" onClick={props.onAboutClicked}>
              About Mee!
            </Button>
          </div>
        </div>
        <Memoji />
      </div>
    </section>
  );
};

export default Home;
